export default "__VITE_ASSET__65581fe7__"